export const getMessageDialogData = (state) => state.MessageDialogData.Data;
